import {
  CREATE_RECEIVAL_LOT_FROM_CONSIGNMENT_FORM,
  DELETE_CONSIGNMENT_FROM_GENERAL_FORM,
  EDIT_RECEIVAL_LOT_FROM_CONSIGNMENT_FORM,
  SUBMIT_CONSIGNMENT_FORM,
  TOGGLE_CONSIGNMENT_MODAL_SECTION,
} from "constants/actionTypes";
import { ConsignmentModalSection } from "constants/navigation";
import { FormikSnapshot } from "sagas/modals/util";

export interface PromptDeleteAction {
  type: typeof DELETE_CONSIGNMENT_FROM_GENERAL_FORM.ACTION;
  consignmentId: string;
}

export function promptDeleteConsignmentFromModal(
  consignmentId: string,
): PromptDeleteAction {
  return {
    type: DELETE_CONSIGNMENT_FROM_GENERAL_FORM.ACTION,
    consignmentId,
  };
}

export interface DeleteConfirmedAction {
  type: typeof DELETE_CONSIGNMENT_FROM_GENERAL_FORM.REQUEST;
  consignmentId: string;
}

export function deleteConsignmentFromModalConfirmed(
  consignmentId: string,
): DeleteConfirmedAction {
  return {
    type: DELETE_CONSIGNMENT_FROM_GENERAL_FORM.REQUEST,
    consignmentId,
  };
}

export interface ToggleConsignmentModalSectionAction {
  type: typeof TOGGLE_CONSIGNMENT_MODAL_SECTION;
  section: ConsignmentModalSection;
}
export function toggleConsignmentModalSection(
  section: ConsignmentModalSection,
): ToggleConsignmentModalSectionAction {
  return { type: TOGGLE_CONSIGNMENT_MODAL_SECTION, section };
}

interface ConsignmentFormValues {
  agency_id: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Type this Address interface
  pickupAddress: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Type this SaleLot partial
  saleLot: any;
  receivalLotIds?: string[];
  rememberAgencyId: boolean;
  shouldUpdateVendorDefaultConsigningDeployment: boolean;
  useVendorAddressAsPickupAddress: boolean;
  vendor_id: string;
}

export interface EditReceivalLotAction {
  type: typeof EDIT_RECEIVAL_LOT_FROM_CONSIGNMENT_FORM;
  receivalLotId: string;
  consignmentId: string;
  formikSnapshot?: FormikSnapshot<ConsignmentFormValues>;
}
export function editReceivalLotFromConsignmentForm(
  receivalLotId: string,
  consignmentId: string,
  formikSnapshot?: FormikSnapshot<ConsignmentFormValues>,
): EditReceivalLotAction {
  return {
    type: EDIT_RECEIVAL_LOT_FROM_CONSIGNMENT_FORM,
    receivalLotId,
    consignmentId,
    formikSnapshot,
  };
}

export interface CreateReceivalLotAction {
  type: typeof CREATE_RECEIVAL_LOT_FROM_CONSIGNMENT_FORM;
  penName: string;
  formikSnapshot?: FormikSnapshot<ConsignmentFormValues>;
}
export function createReceivalLotFromConsignmentForm(
  penName: string,
  formikSnapshot?: FormikSnapshot<ConsignmentFormValues>,
): CreateReceivalLotAction {
  return {
    type: CREATE_RECEIVAL_LOT_FROM_CONSIGNMENT_FORM,
    penName,
    formikSnapshot,
  };
}

export interface SubmitFormAction {
  type: typeof SUBMIT_CONSIGNMENT_FORM;
  consignmentId: string;
  values: ConsignmentFormValues;
  isNew: boolean;
}
export function submitConsignmentForm(
  consignmentId: string,
  values: ConsignmentFormValues,
  isNew: boolean,
): SubmitFormAction {
  return {
    type: SUBMIT_CONSIGNMENT_FORM,
    consignmentId,
    values,
    isNew,
  };
}
